<script setup lang="ts">
import InvoiceHeader from '@/components/Invoice/InvoiceHeader.vue'
import InvoiceInformation from '@/components/Invoice/InvoiceInformation.vue'
import InvoiceTable from '@/components/Invoice/InvoiceTable.vue'
import { usePejer } from '@/Pejer'
import PagePrintState from 'pejer/src/components/PagePrintState.vue'
import usePejerQuery from 'pejer/src/usePejerQuery'
import { useRoute } from 'vue-router'

const route = useRoute()
const paymentReferenceID = route.params.paymentReferenceID as string
const versionNumber = route.query.v as string
const parsedVersion = versionNumber ? parseInt(versionNumber) : undefined

const pejer = usePejer()
const { data, dataState, isLoading, isError, error } = usePejerQuery(
  pejer.urls.invoice.get,
  {
    queryKey: ['payments', paymentReferenceID],
    staleTime: 0,
    pathArgs: { paymentReferenceID },
    select: (data) => {
      if (!parsedVersion || isNaN(parsedVersion) || parsedVersion < 1) return data

      data.orderDetails.productLines = data.orderDetails.productLines.filter((x) =>
        x.paymentVersionNumber === null || x.paymentVersionNumber <= parsedVersion ? true : false
      )

      return data
    },
  },
  { ignoreAuthorization: true }
)
</script>
<template>
  <div
    class="flex min-h-dvh items-center justify-center w-full bg-slate-200/50 heropattern-wiggle-white"
  >
    <PagePrintState
      :isLoading="isLoading"
      :isError="isError"
      :error="error?.error || 'En feil oppstod'"
    />
    <div
      class="p-8 print:shadow-none shadow-md rounded-sm print:p-0 bg-none max-w-[21cm] w-full h-fit min-h-[29.7cm] print:min-h-screen print:max-w-full bg-white text-slate-700"
    >
      <div class="flex flex-col gap-8">
        <InvoiceHeader :invoiceDetails="data" :dataState="dataState"> Faktura </InvoiceHeader>
        <InvoiceInformation :invoiceDetails="data" :dataState="dataState" />
        <InvoiceTable
          :orderDetails="data?.orderDetails"
          :dataState="dataState"
          :paymentStatus="data?.paymentStatus"
          :invoice="data?.invoice"
        />
        <template v-if="isError">
          <div class="w-screen h-screen backdrop-blur-sm absolute top-0 left-0"></div>
          <div
            class="bg-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-8 rounded-lg shadow-sm border border-slate-200 w-full max-w-sm text-red-500"
          >
            <h1 class="font-semibold">En feil oppstod:</h1>
            <p>
              {{ error.error }}
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
